module.exports = __webpack_public_path__ + "img/sze_logo.92cdd6d0.png";